"use client";

import React, { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { usePathname, useRouter } from "next/navigation";
import GermanFlag from "../../../../../public/images/New-landing/germany.svg";
import EnglishFlag from "../../../../../public/images/New-landing/uk.svg";
import { intlPaths } from "../../../(utils)/variables";
import { queryClient } from "../../../ReactQueryWrapper";
import { currentLanguage } from "../../../../../utils/services/dashboard";

interface LanguageSelectorProps {
  className?: string;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  className = "",
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const [isHovered, setIsHovered] = useState(false);

  const { mutate } = useMutation({
    mutationFn: currentLanguage,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["profile-info"] });
      queryClient.invalidateQueries({ queryKey: ["Orders"] });
      queryClient.invalidateQueries({ queryKey: ["Members"] });
    },
  });

  useEffect(() => {
    const currentLang = pathname?.includes(intlPaths.english) ? "en" : "de";
    mutate({ lang: currentLang });
  }, [pathname, mutate]);

  const isEnglish = pathname?.includes(intlPaths.english);
  const CurrentFlag = isEnglish ? EnglishFlag : GermanFlag;
  const NextFlag = isEnglish ? GermanFlag : EnglishFlag;

  const handleLanguageChange = (newLang: string) => {
    if (pathname) {
      const newPath =
        newLang === "en"
          ? `/en${pathname.slice(3)}`
          : `/de${pathname.slice(3)}`;
      router.push(newPath);
    }
  };

  const handleClick = () => {
    const nextLang = isEnglish ? "de" : "en";
    handleLanguageChange(nextLang);
  };

  return (
    <div className={`relative inline-block text-left ${className}`}>
      <button
        className="flex items-center rounded-full hover:bg-white/10 transition-colors duration-200 p-1"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleClick}
      >
        <div className="flex items-center space-x-2 group">
          <div className="w-6 h-6 relative">
            <CurrentFlag 
              className={`w-6 h-6 absolute inset-0 transition-opacity duration-300 ease-in-out ${
                isHovered ? 'opacity-0' : 'opacity-100'
              }`} 
            />
            <NextFlag 
              className={`w-6 h-6 absolute inset-0 transition-opacity duration-300 ease-in-out ${
                isHovered ? 'opacity-100' : 'opacity-0'
              }`} 
            />
          </div>
        </div>
      </button>

    </div>
  );
};

export default LanguageSelector;
